import Tooltip from '@ui/tooltip';
import { type FC } from 'react';
import styles from './index.module.scss';
import needIcon from '@assets/images/icons/need.svg';
import { Link } from 'react-router-dom';
const NeedHelp: FC = () => {
  return (
    <Tooltip
      overlay={
        <div className={styles.need_con}>
          If you have any questions, please contact the turbos team for help.
          <Link to="https://t.me/sydneywolfey" target={'_blank'}>
            Telegram1
          </Link>
          ,
          <Link to="https://t.me/allisonxyz" target={'_blank'}>
            Telegram2
          </Link>
        </div>
      }
      placement="bottom"
    >
      <div className={`${styles.need}`}>
        <img src={needIcon} />
        Need Help?
      </div>
    </Tooltip>
  );
};

export default NeedHelp;
